export default __webpack_public_path__ + "static/media/profileVideo.f50ba992.mp4";